import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { PublicLayout } from "@/components/app/PublicLayout";
import { Spinner } from "@/components/app/common";
import { useAuth } from "@/context/AuthContext";
import { api, dt } from "@/lib/api";

export const RichText = ({ text }) => (
  <div className="space-y-4 leading-relaxed text-muted-foreground">
    {(text || "").split(/\n{2,}/).map((block, i) =>
      block.startsWith("## ") ? <h2 key={i} className="pt-4 text-xl font-semibold text-foreground">{block.slice(3)}</h2>
        : <p key={i} className="whitespace-pre-line">{block}</p>
    )}
  </div>
);

export const LegalPage = () => {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setDoc(null);
    api.get(`/public/legal/${slug}`).then(({ data }) => { setDoc(data); document.title = `${data.title} | AI Creative Studio`; }).catch(() => setErr(true));
  }, [slug]);
  return (
    <PublicLayout>
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-8" data-testid="legal-page">
        {err ? <p>Sayfa bulunamadı.</p> : !doc ? <Spinner /> : (
          <>
            <h1 className="text-3xl font-bold sm:text-4xl" data-testid="legal-title">{doc.title}</h1>
            <div className="mt-3 text-xs text-muted-foreground" data-testid="legal-version">Versiyon {doc.version} · Son güncelleme: {dt(doc.updated_at)}</div>
            <div className="mt-10"><RichText text={doc.content} /></div>
          </>
        )}
      </article>
    </PublicLayout>
  );
};

export const ContactPage = () => {
  const { settings } = useAuth();
  const items = [[Mail, "E-posta", settings.contact_email], [Phone, "Telefon", settings.contact_phone], [MapPin, "Adres", settings.address]];
  return (
    <PublicLayout>
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-8" data-testid="contact-page">
        <div className="eyebrow">İletişim</div>
        <h1 className="mt-3 text-3xl font-bold sm:text-4xl">Size nasıl yardımcı olabiliriz?</h1>
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {items.map(([I, l, v]) => (
            <div key={l} className="glass-card p-6">
              <I className="h-5 w-5 text-primary" />
              <div className="mt-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{l}</div>
              <div className="mt-1 break-words font-medium">{v || "Yakında eklenecek"}</div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
};
